import { wordsResponse } from '../../../textbook/types';
import { AudioAction, AudioActionTypes } from '../type';

interface audioState {
  words: wordsResponse[];
  group: number;
  answers: string[];
  question: number;
  loading: boolean;
}
const initialState: audioState = {
  words: [],
  group: -1,
  answers: [],
  question: 0,
  loading: false,
};

export const audioReducer = (state = initialState, action: AudioAction) => {
  switch (action.type) {
    case AudioActionTypes.FETCH_AUDIO_WORDS_SUCCESS:
      return {
        ...state,
        words: action.payload,
        loading: false,
      };
    case AudioActionTypes.FETCH_AUDIO_WORDS:
      return {
        ...state,
        loading: true,
      };
    case AudioActionTypes.UPDATE_ANSWER:
      return {
        ...state,
        answers: action.payload,
      };
    case AudioActionTypes.UPDATE_QUESTION:
      return {
        ...state,
        question: action.payload,
      };
    case AudioActionTypes.UPDATE_GROUP:
      return {
        ...state,
        group: action.payload,
      };
    case AudioActionTypes.UPDATE_WORDS:
      return { ...state, words: action.payload };
    case AudioActionTypes.REMOVE_WORDS:
      return {
        ...state,
        words: [],
        answers: [],
      };
    default:
      return state;
  }
};
